import React, {useEffect, useState} from "react"
import { Navbar } from "reactstrap"
import classnames from "classnames"
import { connect } from "react-redux"
import NavbarBookmarks from "./NavbarBookmarks"
import NavbarUser from "./NavbarUser"
import userImg from "../../../assets/img/portrait/small/avatar-s-11.jpg"
import Logo from "../../../assets/img/logo/logo.png";
import LogoHeader from "../../../assets/img/logo/logoHeading.png";
import {NavLink} from "react-router-dom";

import { getCurrentOrganization } from "../../../redux/actions/organization"

const ThemeNavbar = props => {
  const colorsArr = [ "primary", "danger", "success", "info", "warning", "dark"]
  const navbarTypes = ["floating" , "static" , "sticky" , "hidden"]
  let [apiCall, setApiCall] = useState(false)

  useEffect(  () => {
    fetchData().then(r =>({}))
  }, [])

  let fetchData = async () => {
    if(props.authUser.org_public_id && props.authUser.org_public_id != ""){
      await props.getCurrentOrganization({
        org_public_id: props.authUser.org_public_id
      })
      setApiCall(true);
    }
  }
console.log(' from Navbar: ', props);

  return (
    <React.Fragment>
      <div className="content-overlay" />
      <div className="header-navbar-shadow" />
      <Navbar
        className={classnames(
          "header-navbar navbar-expand-lg navbar navbar-with-menu navbar-shadow",
          {
            "navbar-light": props.navbarColor === "default" || !colorsArr.includes(props.navbarColor),
            "navbar-dark": colorsArr.includes(props.navbarColor),
            "bg-primary":
              props.navbarColor === "primary" && props.navbarType !== "static",
            "bg-danger":
              props.navbarColor === "danger" && props.navbarType !== "static",
            "bg-success":
              props.navbarColor === "success" && props.navbarType !== "static",
            "bg-info":
              props.navbarColor === "info" && props.navbarType !== "static",
            "bg-warning":
              props.navbarColor === "warning" && props.navbarType !== "static",
            "bg-dark":
              props.navbarColor === "dark" && props.navbarType !== "static",
            "d-none": props.navbarType === "hidden" && !props.horizontal,
            "floating-nav":
              (props.navbarType === "floating" && !props.horizontal) || (!navbarTypes.includes(props.navbarType) && !props.horizontal),
            "navbar-static-top":
              props.navbarType === "static" && !props.horizontal,
            "fixed-top": props.navbarType === "sticky" || props.horizontal,
            "scrolling": props.horizontal && props.scrolling

          }
        )}

        style={{
          'backgroundColor': '#444',
          'paddingBottom':'10px',
          'margin':'auto',
          'border-radius':'0'
        }}
      >
        <div className="navbar-wrapper">
          <div className="navbar-container content">
            <div
              className="navbar-collapse d-flex justify-content-between align-items-center"
              id="navbar-mobile"
            >
              <div className="bookmark-wrapper">
                <NavbarBookmarks
                  sidebarVisibility={props.sidebarVisibility}
                  handleAppOverlay={props.handleAppOverlay}
                />
              </div>
              {props.horizontal ? (
                <div className="logo d-flex align-items-center">
                  <img src={Logo} alt='website Name'/>
                  {/* <img src={LogoHeader} alt='website Name'/> */}
                </div>

              ) : null}
              <NavbarUser
                handleAppOverlay={props.handleAppOverlay}
                changeCurrentLang={props.changeCurrentLang}
                currentOrgID={props.authUser.org_public_id}
                currentOrg={props.current_organization.name}
                userName={props.authUser.first_name + ' ' + props.authUser.last_name }
                userImg={ userImg }
                authUser={props.authUser}
              />
            </div>
          </div>
        </div>
      </Navbar>
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    current_organization: state.organizationList.current_org.org ? state.organizationList.current_org.org[0] : {},
    authUser: state.auth.login.loggedInUser,
  }
}

const mapDispatchToProps = {
  getCurrentOrganization
}

export default connect(mapStateToProps, mapDispatchToProps)(ThemeNavbar);
